module.exports = __webpack_public_path__ + "img/cock.fff513e5.svg";